module.exports = __webpack_public_path__ + "img/logo.ce49b39.png";